import { z } from "zod";

export type BroadcastStatus = z.infer<typeof BroadcastStatusSchema>;
export const BroadcastStatusSchema = z.object({
  status: z.boolean(),
});
